import { Component } from 'san';

import { IManager } from 'src/models';
import { dateFormat } from 'src/filters';

export default class ManagersList extends Component {
    constructor(options: any) {
        super(options);
    }

    static filters = {
        dateFormat
    }

    initData() {
        return {
            items: [],   // (input)
            showCreatedOn: false,   // (input)
            editEnable: false   // (input)
        };
    }

    inited() {
    }

    delete(item: IManager) {
        this.dispatch('UI:managers-list-delete', item);
    }
}